import fc from '../businessLogic/fetchInterceptor';
import { displayGlobalMessage } from '../actions/globalMessage';

export const PAGE_CHANGED = 'PAGE_CHANGED';
export const CLEAR_CACHE_START = 'CLEAR_CACHE_START';
export const CLEAR_CACHE_SUCCESS = 'CLEAR_CACHE_SUCCESS';
export const CLEAR_CACHE_FAIL = 'CLEAR_CACHE_FAIL';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';

export function pageChanged(pageName) {
  return (dispatch) => {
    dispatch({ type: PAGE_CHANGED, data: pageName });
  };
}

export function clearCacheAsync() {
  return (dispatch) => {
    dispatch(
      displayGlobalMessage({
        text: APP.LANGUAGE.ClearCache.Start,
        visible: true,
        messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
        autoHide: true,
      })
    );
    fc.get(window.APP.CONFIGURATION.VCCAPI + 'users/clearcache')
      .then(
        (data) => {
          let msg = APP.LANGUAGE.ClearCache.Success;
          msg = msg.replace('##diff##', data.before - data.after);
          msg = msg.replace('##before##', data.before);
          dispatch(
            displayGlobalMessage({
              text: msg,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        },
        (error) => {
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ClearCache.Fail,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: true,
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'users/clearcache',
              browserURL: window.location.href,
            })
          );
          console.error('Error happens when clearing cache:', error);
        }
      )
      .catch((err) => console.error('There was an API error', err));
  };
}

export function previousPage(pageName) {
  return (dispatch) => {
    dispatch({ type: PREVIOUS_PAGE, data: pageName });
  };
}
